var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSquareDashedMousePointer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "lucide lucide-square-dashed-mouse-pointer-icon lucide-square-dashed-mouse-pointer",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.034 12.681a.498.498 0 0 1 .647-.647l9 3.5a.5.5 0 0 1-.033.943l-3.444 1.068a1 1 0 0 0-.66.66l-1.067 3.443a.5.5 0 0 1-.943.033z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5 3a2 2 0 0 0-2 2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19 3a2 2 0 0 1 2 2"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5 21a2 2 0 0 1-2-2"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9 3h1"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9 21h2"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M14 3h1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M3 9v1"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M21 9v2"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M3 14v1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareDashedMousePointer);
export default __webpack_public_path__ + "static/media/square-dashed-mouse-pointer.0302917a44471072724df5d8ee28b99d.svg";
export { ForwardRef as ReactComponent };